{
  "fr": {
    "hangarPlanner": {
      "title": "Planificateur de hangar",
      "lead": "Planifiez le hangar que vous voulez en emplacements (les rôles à couvrir) et déterminez comment y arriver depuis votre hangar actuel : ce que vous gardez, ce que vous melt et quels upgrades et buy-backs utiliser.",
      "createPlan": "Nouveau plan",
      "editPlan": "Modifier le plan",
      "destroyPlan": "Supprimer le plan",
      "confirmDestroy": "Supprimer ce plan ? Votre hangar n'est pas modifié.",
      "share": "Partager par lien",
      "copyShareLink": "Copier le lien de partage",
      "unshare": "Arrêter le partage",
      "shared": "Partagé",
      "sharedMissing": "Ce plan n'est pas partagé, ou le lien a changé.",
      "addToWishlist": "Ajouter les achats à la liste de souhaits",
      "confirmAddToWishlist": "Ajouter à votre liste de souhaits chaque vaisseau que ce plan doit encore obtenir ?",
      "compareWith": "Comparer avec %{plan}",
      "compareTitle": "%{left} vs. %{right}",
      "slotsCount": {
        "one": "%{count} emplacement",
        "other": "%{count} emplacements"
      },
      "updatedAt": "Mis à jour le %{date}",
      "empty": {
        "title": "Aucun plan pour l'instant",
        "text": "Commencez un plan de zéro, depuis votre hangar, depuis votre liste de souhaits ou en copiant un autre plan."
      },
      "noSlots": "Ce plan n'a pas encore d'emplacement. Ajoutez un emplacement pour chaque rôle que votre hangar doit couvrir.",
      "placeholderRoles": {
        "starter": "Vaisseau du quotidien",
        "cargo": "Cargo",
        "exploration": "Explorateur"
      },
      "useAsFirstSlot": "En faire mon premier emplacement",
      "addSlot": "Ajouter un emplacement",
      "editSlot": "Modifier l'emplacement",
      "editSlotOf": "Modifier %{slot}",
      "slotSettings": "Nom et filtres",
      "removeSlot": "Retirer l'emplacement",
      "confirmRemoveSlot": "Retirer cet emplacement avec ses vaisseaux et ses voies d'obtention ?",
      "openSlotHint": "Aucun vaisseau choisi pour l'instant. Ajoutez-en un, ou plusieurs si vous hésitez.",
      "addShips": "Ajouter des vaisseaux",
      "addCandidates": "Vaisseaux pour %{slot}",
      "addToSlot": "Ajouter à l'emplacement",
      "inSlot": "Dans cet emplacement",
      "choose": "Choisir",
      "chooseHint": "Choisissez le vaisseau que cet emplacement retient. Les autres vaisseaux quittent l'emplacement, avec leurs voies d'obtention.",
      "removeCandidate": "Retirer le vaisseau",
      "ownedCount": {
        "one": "%{count} dans votre hangar",
        "other": "%{count} dans votre hangar"
      },
      "notOnSale": "non vendu",
      "routes": "Comment les obtenir",
      "editRoute": "Voie vers %{ship}",
      "removeRoute": "Retirer la voie",
      "unresolvedUnits": {
        "one": "%{count} vaisseau n'a pas encore de voie",
        "other": "%{count} vaisseaux n'ont pas encore de voie"
      },
      "routeMustEnd": "La voie doit se terminer sur le %{ship}.",
      "upgradeSteps": "Upgrades",
      "stepNumber": "Upgrade %{number}",
      "addStep": "Ajouter un upgrade",
      "removeStep": "Retirer l'upgrade",
      "sourceMissing": "n'est plus dans votre hangar",
      "melts": "Melts",
      "noMelts": "Aucun vaisseau à melt.",
      "addMelt": "Melt un vaisseau",
      "editMelt": "Modifier le melt",
      "removeMelt": "Garder le vaisseau",
      "estimated": "estimation",
      "free": "Gratuit",
      "unknownPrice": "Inconnu",
      "fields": {
        "name": "Nom",
        "description": "Description",
        "startingCredit": "Crédit boutique",
        "startingCreditInfo": "Crédit boutique que vous avez déjà, en USD.",
        "source": "Partir de",
        "sourcePlan": "Plan à copier",
        "slotLabel": "Rôle",
        "slotLabelPlaceholder": "p. ex. Cargo principal",
        "quantity": "Vaisseaux",
        "startKind": "Commence comme",
        "ownedShip": "Vaisseau de votre hangar",
        "buyback": "Pledge de buy-back",
        "priceOverride": "Prix payé",
        "priceOverrideInfo": "Laissez vide pour utiliser le prix actuel de la boutique, ou saisissez un prix de promotion ou de warbond.",
        "upgradeSource": "Upgrade depuis",
        "ownedUpgrade": "Upgrade dans votre hangar RSI",
        "upgradeTo": "Upgrade vers",
        "meltShip": "Vaisseau à melt",
        "meltValue": "Crédit",
        "meltValueInfo": "Ce que la fonte rapporte. Laissez vide pour utiliser la valeur que RSI donne au pledge, ou le prix boutique du jour si la synchronisation du hangar ne l'a pas lue.",
        "slotDescription": "Description",
        "filters": "Vaisseaux adaptés",
        "filtersInfo": "Le sélecteur de vaisseaux s'ouvre avec ces filtres. Les vaisseaux hors filtres peuvent quand même être ajoutés et sont signalés.",
        "priceFrom": "Prix à partir de",
        "priceTo": "Prix jusqu'à",
        "minCargo": "Cargo minimum",
        "onSaleOnly": "Uniquement les vaisseaux en vente",
        "buybackTokens": "Jetons de rachat",
        "buybackTokensInfo": "Chaque jeton permet de payer un rachat avec du crédit boutique. Sans jeton, un rachat coûte de l'argent frais.",
        "buybackTokensSynced": "Chaque jeton permet de payer un rachat avec du crédit boutique. Votre dernière synchronisation des rachats en a lu %{count} chez RSI ; laissez vide pour utiliser cette valeur.",
        "vatRate": "TVA",
        "vatRateInfo": "La TVA que RSI ajoute au paiement selon ton pays, p. ex. 20 en France. Elle ne s'applique qu'à l'argent neuf ; le crédit boutique l'inclut déjà."
      },
      "sources": {
        "empty": "Un plan vide",
        "hangar": "Mon hangar",
        "wishlist": "Ma liste de souhaits",
        "plan": "Un autre plan"
      },
      "states": {
        "open": "Ouvert",
        "decided": "Décidé",
        "undecided": "Indécis"
      },
      "startKinds": {
        "owned": "Gardé du hangar",
        "store": "Achat en boutique",
        "ingame": "Acheté en jeu",
        "buyback": "Buy-back"
      },
      "upgradeSources": {
        "store": "Boutique",
        "owned_ccu": "Mon hangar RSI",
        "buyback": "Buy-back"
      },
      "vehicleStatuses": {
        "kept": "Gardé",
        "upgraded": "Upgradé",
        "unrouted": "Parcours manquant",
        "melted": "Melt",
        "pending": "À décider",
        "change": "Doit changer",
        "unassigned": "Hors plan"
      },
      "changes": {
        "added": "Nouveau",
        "removed": "Parti",
        "more": "Plus",
        "fewer": "Moins",
        "unchanged": "Identique"
      },
      "issues": {
        "missing_price": "%{name} n'a pas de prix connu, le total l'ignore donc.",
        "not_on_sale": "%{name} n'est pas en vente actuellement."
      },
      "summary": {
        "title": "Coûts",
        "spend": "Nouvelles dépenses",
        "routedSpend": "Dépenses avec voie",
        "maxSpend": "Maximum possible",
        "upTo": "jusqu'à %{value}",
        "meltCredit": "Crédit des melts",
        "startingCredit": "Crédit boutique",
        "net": "Coût net",
        "cashNeeded": "Reste à payer",
        "remainingCredit": "Crédit restant",
        "estimatedMelts": {
          "one": "%{count} estimé",
          "other": "%{count} estimés"
        },
        "openSlots": {
          "one": "%{count} emplacement sans vaisseau",
          "other": "%{count} emplacements sans vaisseau"
        },
        "undecidedSlots": {
          "one": "%{count} emplacement indécis",
          "other": "%{count} emplacements indécis"
        },
        "unresolved": {
          "one": "%{count} vaisseau sans voie",
          "other": "%{count} vaisseaux sans voie"
        },
        "incomplete": "Le total est incomplet",
        "complete": "Chaque vaisseau a une voie et un prix.",
        "buybackCash": "Rachats en argent frais",
        "buybacksWithoutToken": {
          "one": "%{count} rachat sans jeton",
          "other": "%{count} rachats sans jeton"
        },
        "tokensShort": {
          "one": "%{count} rachat utilise un jeton, mais vous en avez %{available}. Le reste compte comme argent frais.",
          "other": "%{count} rachats utilisent un jeton, mais vous en avez %{available}. Le reste compte comme argent frais."
        }
      },
      "comparison": {
        "title": "Comparé à votre hangar",
        "yourShips": "Vos vaisseaux",
        "noShips": "Votre hangar n'a aucun vaisseau.",
        "changes": "Changements",
        "noChanges": "Aucun changement.",
        "toAcquire": "Reste à obtenir",
        "hangar": "Hangar",
        "plan": "Plan",
        "happens": "Ce qui se passe",
        "meltCredit": "%{value} de crédit",
        "leaves": "Quitte votre hangar",
        "notOwned": "Pas dans votre hangar",
        "lead": "À gauche chaque vaisseau que vous possédez, à droite chaque vaisseau dont le plan a besoin, et entre les deux ce qui se passe.",
        "anotherPlan": "Comparer avec un autre plan",
        "tallies": {
          "pending": {
            "one": "%{count} à décider",
            "other": "%{count} à décider"
          },
          "change": {
            "one": "%{count} doit changer",
            "other": "%{count} doivent changer"
          },
          "kept": {
            "one": "%{count} conservé",
            "other": "%{count} conservés"
          },
          "upgraded": {
            "one": "%{count} amélioré",
            "other": "%{count} améliorés"
          },
          "unrouted": {
            "one": "%{count} sans parcours",
            "other": "%{count} sans parcours"
          },
          "melted": {
            "one": "%{count} fondu",
            "other": "%{count} fondus"
          },
          "toAcquire": {
            "one": "%{count} reste à obtenir",
            "other": "%{count} restent à obtenir"
          },
          "open": {
            "one": "%{count} emplacement ouvert",
            "other": "%{count} emplacements ouverts"
          }
        },
        "costsTitle": "Ce que ça coûte",
        "flow": {
          "steps": {
            "one": "%{count} amélioration · %{price}",
            "other": "%{count} améliorations · %{price}"
          },
          "shipOf": "vaisseau %{number} sur %{count}",
          "noRoute": "Pas encore de voie",
          "planRoute": "Planifier le parcours",
          "noUpgrade": "Aucun upgrade possible",
          "pickOtherStart": "choisissez un autre départ",
          "notCounted": "hors du total",
          "onlyInMax": "seulement dans le maximum",
          "noShip": "pas encore de vaisseau",
          "folded": {
            "kept": {
              "one": "%{count} gardé tel quel",
              "other": "%{count} gardés tels quels"
            },
            "melted": {
              "one": "%{count} melté",
              "other": "%{count} meltés"
            },
            "unassigned": {
              "one": "%{count} vaisseau hors du plan",
              "other": "%{count} vaisseaux hors du plan"
            }
          }
        },
        "changeSides": {
          "in": "Arrive",
          "out": "Part"
        },
        "unchangedCount": {
          "one": "%{count} modèle reste tel quel.",
          "other": "%{count} modèles restent tels quels."
        },
        "after": "Après le plan"
      },
      "metrics": {
        "title": "Statistiques",
        "total": "Vaisseaux",
        "uniqueModelsCount": "Modèles différents",
        "manufacturerCount": "Constructeurs",
        "flightReadyCount": "Prêts à voler",
        "totalCrew": "Équipage",
        "totalCargo": "Cargo (SCU)",
        "totalPledgeValue": "Valeur boutique",
        "largestShip": "Plus grand vaisseau",
        "smallestShip": "Plus petit vaisseau",
        "classifications": "Classifications",
        "sizes": "Tailles",
        "productionStatuses": "Statut de production"
      },
      "drift": {
        "title": "Votre hangar a changé depuis la création de ce plan",
        "missing": {
          "one": "%{count} vaisseau ou pledge utilisé par le plan a disparu.",
          "other": "%{count} vaisseaux ou pledges utilisés par le plan ont disparu."
        },
        "changed": {
          "one": "%{count} vaisseau est maintenant un autre modèle.",
          "other": "%{count} vaisseaux sont maintenant d'autres modèles."
        },
        "added": "Nouveau dans votre hangar : %{ships}",
        "prices": "Les prix ont changé : %{before} lors de la planification, %{now} aujourd'hui.",
        "rebase": "Mettre à jour depuis le hangar"
      },
      "messages": {
        "saved": "Plan enregistré.",
        "saveFailed": "Cela n'a pas fonctionné. Veuillez vérifier votre saisie.",
        "shareCopied": "Lien de partage copié.",
        "unshared": "Le lien de partage ne fonctionne plus.",
        "addedToWishlist": {
          "one": "%{count} vaisseau ajouté à votre liste de souhaits.",
          "other": "%{count} vaisseaux ajoutés à votre liste de souhaits."
        },
        "rebased": "Plan mis à jour depuis votre hangar.",
        "sharingOn": "Le partage est activé. Toute personne disposant du lien peut voir ce plan.",
        "copyFailed": "Le lien n'a pas pu être copié. Copiez-le depuis le champ.",
        "filtersSaved": "Filtres enregistrés pour %{slot}"
      },
      "filterChips": {
        "priceFrom": "à partir de %{price}",
        "priceTo": "jusqu'à %{price}",
        "cargo": "%{cargo} SCU ou plus",
        "onSale": "en vente"
      },
      "outsideFilters": "hors des filtres de cet emplacement",
      "shareLink": "Lien de partage",
      "specs": {
        "price": "Prix",
        "cargo": "Cargo",
        "crew": "Équipage",
        "size": "Taille",
        "best": "meilleur"
      },
      "readiness": {
        "routed": {
          "one": "%{routed} vaisseau sur %{count} a une voie",
          "other": "%{routed} vaisseaux sur %{count} ont une voie"
        },
        "undecided": "%{slot} est indécis",
        "open": "%{slot} n'a pas de vaisseau",
        "unresolved": {
          "one": "%{slot} : %{count} vaisseau sans voie",
          "other": "%{slot} : %{count} vaisseaux sans voie"
        }
      },
      "meta": {
        "undecided": "%{count} indécis",
        "open": "%{count} ouverts"
      },
      "route": {
        "stillToReach": "Reste à atteindre",
        "yourRoute": "Votre voie",
        "done": "La voie se termine sur le %{ship}.",
        "isTarget": "Même vaisseau",
        "search": "Rechercher",
        "noMatch": "Aucun résultat.",
        "reaches": "Mène au %{ship}",
        "left": {
          "one": "%{count} restante",
          "other": "%{count} restantes"
        },
        "showAll": {
          "one": "Afficher votre %{count} amélioration",
          "other": "Afficher les %{count} améliorations"
        },
        "showFitting": "N'afficher que les améliorations adaptées",
        "unknownTarget": "Vers quel vaisseau elle mène",
        "startCost": "Départ",
        "sort": {
          "price": "Prix",
          "name": "Nom"
        },
        "change": "Changer",
        "from": "Depuis",
        "to": "Vers",
        "todaysPrice": "Prix du jour : %{price}",
        "noStoreShip": "Aucun vaisseau de la boutique ne convient ici.",
        "paidWithCredit": "Crédit boutique",
        "paidWithCash": "Argent neuf",
        "vat": "TVA (%{rate} %)",
        "cashWithVat": "Argent neuf avec TVA",
        "paymentHint": "Le crédit boutique couvre la boutique et les rachats avec jeton. Un rachat sans jeton coûte de l'argent neuf, comme tout ce que ton crédit ne couvre pas.",
        "ownedPaid": "Déjà payée",
        "noHeld": {
          "owned_ccu": "Aucune des améliorations de votre hangar RSI ne part du %{ship}.",
          "buyback": "Aucune de vos améliorations à racheter ne part du %{ship}."
        },
        "shipCard": "Vaisseau",
        "useToken": "Utiliser un jeton de rachat",
        "withToken": "payé avec un jeton"
      },
      "meltList": {
        "none": "D'après RSI, aucun de vos vaisseaux ne peut être fondu. Désactivez le filtre pour choisir n'importe quel vaisseau.",
        "credit": "%{value} de crédit",
        "estimate": "%{value} estimé",
        "wholePledge": {
          "one": "fond %{count} objet",
          "other": "fond tout le pledge : %{count} objets"
        },
        "meltableOnly": "Fondables uniquement",
        "notMeltable": "non fondable",
        "notSynced": "non synchronisé",
        "noShips": "Aucun de vos vaisseaux n'est libre pour être fondu.",
        "inPackage": "dans %{name}",
        "contents": "Fondu avec lui",
        "contentsOf": "Fondu avec lui, dans %{name}",
        "unlisted": {
          "one": "%{count} objet de plus que la synchronisation du hangar ne liste pas",
          "other": "%{count} objets de plus que la synchronisation du hangar ne liste pas"
        }
      },
      "decisions": {
        "keep": "Garder tel quel",
        "melt": "Fondre",
        "change": "Marquer comme doit changer",
        "pending": "Remettre à décider",
        "upgradeTo": "Améliorer %{name} en",
        "keepPending": "Garder tous ceux à décider"
      },
      "pick": {
        "pickStart": "Choisir un départ",
        "pickEnd": "Choisir l'arrivée",
        "startOf": "Choisir le départ pour %{ship}",
        "endOf": "Choisir ce que devient %{ship}",
        "startTitle": "Départ pour %{ship}",
        "startEyebrow": "Vaisseau de départ",
        "endTitle": "Ce que devient %{ship}",
        "endEyebrow": "Vaisseau d'arrivée",
        "buyNew": "Acheter neuf sur le store",
        "current": "Départ actuel",
        "use": "Utiliser",
        "noShips": "Aucun vaisseau du hangar n'est libre pour cet emplacement.",
        "removeStart": "Retirer de l'emplacement",
        "same": "Le même vaisseau, gardé tel quel",
        "sameModel": "Même modèle",
        "noEnds": "Aucun vaisseau que celui-ci puisse devenir.",
        "removeEnd": "Retirer du plan",
        "anyShip": "N'importe quel vaisseau",
        "buyChosen": "Le vaisseau que vous choisissez ensuite",
        "onlyMelt": "Aucun upgrade n'existe pour lui, il ne peut qu'être fondu",
        "excludes": "Exclut %{ships}",
        "ccuSalesOnly": "CCU seulement pendant les ventes",
        "ccuUnknown": "Aucun CCU vu pour l'instant",
        "sources": {
          "hangar": "Votre hangar",
          "buyback": "Buy-back",
          "store": "Store"
        },
        "filters": "Affiner les départs",
        "saveFilters": "Enregistrer les filtres pour cet emplacement",
        "chooseShip": "Choisir un vaisseau",
        "earnInGame": "Gagner en jeu",
        "newSlot": "Nouvel emplacement",
        "endSources": {
          "plan": "Emplacements du plan",
          "catalogue": "N'importe quel vaisseau"
        }
      },
      "slotsTitle": "Emplacements",
      "editSlots": "Modifier les emplacements",
      "slotNumber": "Emplacement %{number}",
      "suggestions": {
        "title": "Suggestions",
        "lead": "Des idées pour le hangar auquel ce plan aboutit, sans les vaisseaux qu'il fond ou améliore.",
        "redundant": "Vaisseaux redondants",
        "noRedundant": "Aucun vaisseau ne fait deux fois le même travail.",
        "duplicate": "%{ship} × %{count}",
        "hints": {
          "duplicate": "Le même vaisseau plusieurs fois. En fondre un de trop rend du crédit store.",
          "role": "%{count} vaisseaux du même rôle. Un seul pourrait suffire."
        },
        "inSlot": "Emplacement %{slot}",
        "inHangar": "Votre hangar"
      }
    }
  }
}
